<div class="row bg-secondary">
  <div class="pr-4 pl-4 mb-2 mt-2">
    <form class="flex-row" (ngSubmit)="filterItems()">
      <div class="form-group pr-3">
        <div class="text-center">
          <label for="searchText" i18n>Item Search</label>
        </div>
        <input id="searchText" name="searchText" class="form-control" [(ngModel)]="itemFilter.searchText">
      </div>
      <div class="form-group pr-3">
        <div class="text-center">
          <label for="itemTypes" i18n>Type</label>
        </div>
        <select name="itemTypes" id="itemTypes" class="form-control select-bidit" [(ngModel)]="itemFilter.itemTypeId">
          <option [ngValue]="null" selected="">-</option>
          <option *ngFor="let type of itemTypes" [(ngValue)]="type.itemType_ID">{{type.itemType_Desc}}</option>
        </select>
      </div>
      <div class="form-group pr-3">
        <div class="text-center">
          <label for="rValues" i18n>R-Value</label>
        </div>
        <select name="rValues" id="rValues" class="form-control select-bidit" [(ngModel)]="itemFilter.rValueId">
          <option [ngValue]="null" selected="">-</option>
          <option *ngFor="let rvalue of rValues" [(ngValue)]="rvalue.rValue_ID">{{rvalue.rValue_Desc}}</option>
        </select>
      </div>
      <div class="form-group pr-3">
        <div class="text-center">
          <label for="statusId" i18n>Status</label>
        </div>
        <select name="statusId" id="statusId" class="form-control select-bidit" [(ngModel)]="itemFilter.statusId">
          <option [ngValue]="null" selected="" i18n>All</option>
          <option [ngValue]="1" i18n>Active</option>
          <option [ngValue]="0" i18n>Inactive</option>
        </select>
      </div>
      <div class="form-group">
        <label for="btnsDiv">&nbsp;</label>
        <div id="btnsDiv">
          <button class="btn btn-md btn-bidit-action mr-2" type="submit" i18n onclick="this.blur();">Apply Filter</button>
          <button class="btn btn-secondary btn-md mr-2" type="button" (click)="initializeSearchCriteria()" i18n>Reset</button>
          <button class="btn btn-bidit-action mr-2" type="button" (click)="exportItems()" i18n>Export</button>
          <button *ngIf="showBulkUpdate" class="btn btn-bidit-cancel btn-md mr-2" type="button" (click)="bulkUpdate()" i18n>Bulk Change</button>
          <button *ngIf="showBulkUpdateReset" class="btn btn-bidit-cancel btn-md" type="button" (click)="bulkUpdateReset()" i18n>Bulk Change Reset</button>
          <button class="btn btn-bidit-action btn-md" type="button" (click)="itemQtyImport()" i18n>Import Inventory</button>
        </div>
      </div>
    </form>
  </div>
</div>
<div class="bg-white pt-3">
  <div class="col-sm-9"><h5 i18n>Items</h5></div>
  <div class="row">
    <div class="col-sm-9" i18n>Unique material codes you use on projects (unique SLI and/or vendor code).</div>
    <div class="col-sm-3">
      <a (click)="showEdit(null)" class="float-right btn btn-bidit-navigate btn-md mb-sm-3" i18n>Add</a>
    </div>
  </div>

  <app-spinner [isRunning]="isRequesting"></app-spinner>
  <table mat-table class="table-bidit table-striped" style="width: 100%;" [dataSource]="dataSource"
        matSort matSortActive="itemName" matSortDirection="asc" >
    <ng-container matColumnDef="itemName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header class="bidit-header" i18n>Item</th>
      <td mat-cell *matCellDef="let item">
        {{item.item_Name}}
      </td>
    </ng-container>
    <ng-container matColumnDef="rValue">
      <th mat-header-cell *matHeaderCellDef mat-sort-header class="bidit-header" i18n>R-Value</th>
      <td mat-cell *matCellDef="let item">
        {{item.rValue?.rValue_Desc}}
      </td>
    </ng-container>
    <ng-container matColumnDef="itemType">
      <th mat-header-cell *matHeaderCellDef mat-sort-header class="bidit-header" i18n>Item Type</th>
      <td mat-cell *matCellDef="let item">
        {{item.itemType?.itemType_Desc}}
      </td>
    </ng-container>
    <ng-container matColumnDef="itemCost">
      <th mat-header-cell *matHeaderCellDef mat-sort-header class="bidit-header" i18n>Item Cost</th>
      <td mat-cell *matCellDef="let item">
        <ng-template [ngIf]="!item.itemType.itemType_IsUsage && !item.itemType.itemType_IsAccessory">${{item.item_Cost_SqrFt | number:'1.2-2'}}</ng-template>
        <ng-template [ngIf]="item.itemType.itemType_IsUsage || item.itemType.itemType_IsAccessory">${{item.item_Cost | number:'1.2-2'}}</ng-template>
      </td>
    </ng-container>
    <ng-container matColumnDef="itemPart">
      <th mat-header-cell *matHeaderCellDef class="bidit-header" i18n>Mfr. Part #</th>
      <td mat-cell *matCellDef="let item">
        <ng-template [ngIf]="!item.external_Item_Part && !item.item_IDIPart">{{item.item_Part}}</ng-template>
        <ng-template [ngIf]="item.external_Item_Part">{{item.external_Item_Part}}</ng-template>
        <ng-template [ngIf]="!item.external_Item_Part && item.item_IDIPart">{{item.item_IDIPart}}</ng-template>
      </td>
    </ng-container>
    <ng-container matColumnDef="itemQtyOnhand">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="itemQtyOnhand" class="bidit-header" i18n>QTY</th>
      <td mat-cell *matCellDef="let item">
        {{item.item_Qty_Onhand}}
      </td>
    </ng-container>
    <ng-container matColumnDef="action">
      <th mat-header-cell *matHeaderCellDef class="bidit-header"></th>
      <td mat-cell *matCellDef="let item">
        <label id="item_status_active{{item.item_ID}}" [ngClass]="{'text-success' : item.item_isActive}" i18n>active</label>
        <input (change)="toggleStatus('item', item.item_ID)" type="checkbox" name="item_status_{{id}}" id="item_status_{{id}}" class="bidit-switch-sm ml-1 mr-1" [ngModel]="!item.item_isActive" (ngModelChange)="item.item_isActive = $event">
        <label id="item_status_inactive{{item.item_ID}}" [ngClass]="{'text-danger' : !item.item_isActive}" i18n>inactive</label>
        <a class="btn btn-bidit-edit-dark ml-4" (click)="showEdit(item.item_ID)"></a>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns">
    </tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>

  <mat-paginator [pageSize]="25" [pageSizeOptions]="[25]"></mat-paginator>
</div>
